jQuery(document).ready(function($) {

  /* PRIMARY NAVIGATION -- DROP-DOWN CONTENT GROUPING --------------- */
  // Groups each Drop-Down's PL (.primary) and SL (.secondary) items into
  // their own containers so CSS can lay them out as two independent
  // columns -- a flat DOM-order list can't be split into two independently
  // wrapping groups with CSS alone. Runs once on ready, not per-click.
  $('#navigation ul.sub-menu').each(function() {

    var $sub_menu = $(this);
    var $primary_items = $('> li.menu-item.primary', $sub_menu);
    var $secondary_items = $('> li.menu-item.secondary', $sub_menu);

    if ($primary_items.length) {
      $primary_items.wrapAll('<div class="sub-menu-primary"></div>');
    }
    if ($secondary_items.length) {
      $secondary_items.wrapAll('<div class="sub-menu-secondary"></div>');
    }

    $sub_menu.toggleClass('has-primary', $primary_items.length > 0);
    $sub_menu.toggleClass('has-secondary', $secondary_items.length > 0);

  });


  /* PRIMARY NAVIGATION -- DESKTOP DROP-DOWN / MOBILE MENU PANEL ---- */
  $('#navigation').each(function() {

    var $navigation = $(this);
    var $tlmis_with_sub_menus = $('> ul.menu > li.menu-item.menu-item-has-children', $navigation);
    var is_mobile_width = function() {
      return window.matchMedia('(max-width: 1200px)').matches;
    };

    // Mobile drill-down: rather than the top-level list reflowing item by
    // item (which read as TLMIs "jumping"/swapping places), the whole
    // ul.menu fades out as one unit and the active TLMI's Drop-Down fades
    // in as an overlay in the same spot. Since that hides the TLMI's own
    // row (it's part of ul.menu), a dedicated back header takes its place,
    // built once here and prepended to #navigation.
    var $back_header = $(
      '<div class="mobile-back-header">' +
        '<button type="button" class="mobile-back-trigger" aria-label="Mobile Menu Back Button"><span class="mobile-back-label"></span></button>' +
      '</div>'
    );
    $navigation.prepend($back_header);
    var $back_label = $('.mobile-back-label', $back_header);
    var $back_trigger = $('.mobile-back-trigger', $back_header);
    var $last_active_trigger = null;

    // Locks background scroll (body.nav-dropdown-open, see .scss) whenever
    // any TLMI is active -- desktop or mobile, so it's kept in sync from
    // every place .active changes, rather than each caller managing it.
    var $body = $('body');
    var update_dropdown_scroll_lock = function() {
      $body.toggleClass('nav-dropdown-open', $tlmis_with_sub_menus.filter('.active').length > 0);
    };

    var close_active_tlmi = function() {
      $tlmis_with_sub_menus.removeClass('active')
        .children('a, .no-link').attr('aria-expanded', 'false');
      $navigation.removeClass('mobile-drilldown');
      $navigation.css('min-height', '');
      update_dropdown_scroll_lock();
    };

    // The top-level list (ul.menu) is always in normal flow, so its own
    // height is already #navigation's natural floor -- that part needs no
    // extra work. But ul.sub-menu is position: absolute (so it doesn't
    // reflow siblings), which also means it can never grow #navigation to
    // fit it the way in-flow content would; CSS has no way to size an
    // ancestor to an absolutely-positioned descendant. So when a Drop-Down
    // opens, measure its actual content height (scrollHeight still reports
    // this correctly even while it's visually collapsed via max-height:0)
    // and apply it as an inline min-height on #navigation -- min-height,
    // not height, so it still can't go below ul.menu's own floor.
    // Capped at window.innerHeight in JS rather than trusting #navigation's
    // own max-height: 100vh (CSS) to cap it: when a specified min-height
    // is larger than max-height, min-height wins -- the used max-height is
    // pushed up to match it, not the other way around. Uncapped, a tall
    // Drop-Down could grow #navigation past the viewport, and since the
    // body is scroll-locked while the panel is open, that overflow became
    // genuinely unreachable (#navigation's own overflow-y: auto had
    // nothing to do, since its box no longer overflowed itself).
    var apply_drilldown_height = function($sub_menu) {
      var nav_padding_bottom = parseFloat($navigation.css('padding-bottom')) || 0;
      var sub_menu_top = $sub_menu.position().top;
      var required_height = sub_menu_top + $sub_menu[0].scrollHeight + nav_padding_bottom;
      required_height = Math.min(required_height, window.innerHeight);
      $navigation.css('min-height', required_height + 'px');
    };

    // Desktop only: every Drop-Down positions itself relative to its own
    // TLMI now rather than the header -- wide (PL) Drop-Downs left-align
    // with the trigger, narrow SL-only ones (see .scss for the
    // has-secondary:not(.has-primary) width override) center under it.
    // Both are clamped to $wrap's own bounds so they "attempt" to align
    // without overflowing the header, e.g. for Log In sitting at the
    // right edge. Uses getBoundingClientRect rather than jQuery's
    // .position(), which deliberately SUBTRACTS an element's own resolved
    // margin from its result (see jQuery source -- offset.left -
    // parentOffset.left - marginLeft). That's invisible for every
    // ordinary TLMI (margin-left: 0), but .desktop-menu-end items (Log
    // In) are pushed right via margin-left: auto, which resolves to a
    // large concrete px value once rendered -- .position() would subtract
    // that whole amount back out, reporting a position far to the left of
    // where the trigger actually renders. getBoundingClientRect always
    // reflects true rendered geometry regardless of how it was achieved.
    var $wrap = $navigation.parent();
    var clear_position_timer;
    var position_drop_down = function($item, $sub_menu) {

      var is_narrow = $sub_menu.hasClass('has-secondary') && !$sub_menu.hasClass('has-primary');
      var item_rect = $item[0].getBoundingClientRect();
      var wrap_rect = $wrap[0].getBoundingClientRect();
      var width, left;

      if (is_narrow) {

        // Centered under the trigger, fixed width (set in CSS)
        width = $sub_menu.outerWidth();
        left = (item_rect.left - wrap_rect.left) + (item_rect.width / 2) - (width / 2);

      } else {

        // Left-edge aligned with the trigger. Width has to be computed
        // here too, not just capped at 1330px in CSS: the header's own
        // available width can be narrower than that within the desktop
        // range (its side padding already shrinks at the 1600px/1300px
        // breakpoints in style-responsive.scss).
        width = Math.min(1330, wrap_rect.width);
        left = item_rect.left - wrap_rect.left;
        $sub_menu.css('width', width + 'px');

      }

      left = Math.max(0, Math.min(left, wrap_rect.width - width));
      $sub_menu.css('left', left + 'px');

    };

    $tlmis_with_sub_menus.each(function() {

      var $item = $(this);
      var $trigger = $('> a, > .no-link', $item);

      $trigger.attr('aria-expanded', 'false').on('click', function(e) {

        e.preventDefault();

        var was_active = $item.hasClass('active');

        // Only one Drop-Down can be open at a time, so close any others first
        $tlmis_with_sub_menus.not($item).removeClass('active')
          .children('a, .no-link').attr('aria-expanded', 'false');

        // Toggle this one
        $item.toggleClass('active', !was_active);
        $trigger.attr('aria-expanded', !was_active);
        update_dropdown_scroll_lock();

        // Desktop only -- position relative to the trigger when opening;
        // clear that inline left/width again on close so it can't linger
        // and silently override mobile's own CSS positioning (inline
        // styles beat any stylesheet rule, including inside a media
        // query) if the window is later resized narrow without this
        // Drop-Down having been reopened at desktop width in between.
        // The clear itself waits for the close fade (200ms, matching the
        // opacity transition in the .scss) rather than running immediately
        // -- otherwise it snaps back to its CSS default position while
        // still visible, then fades out from there. Canceled on reopen so
        // a rapid close-then-reopen can't have the stale timer fire after
        // the new position has already been set.
        if (!is_mobile_width()) {

          clearTimeout(clear_position_timer);

          if (!was_active) {
            position_drop_down($item, $('> ul.sub-menu', $item));
          } else {
            var $sub_menu_to_clear = $('> ul.sub-menu', $item);
            clear_position_timer = setTimeout(function() {
              $sub_menu_to_clear.css({ left: '', width: '' });
            }, 200);
          }

        }

        // On mobile, an active TLMI drills into its Drop-Down as a
        // second-level view instead of revealing it inline
        if (is_mobile_width()) {

          $navigation.toggleClass('mobile-drilldown', !was_active);
          $navigation.scrollTop(0);

          if (!was_active) {
            var $label_source = $('.menu-item-title, .menu-link-text', $trigger).first();
            $back_label.text($label_source.length ? $label_source.text() : $trigger.text());
            $last_active_trigger = $trigger;
            apply_drilldown_height($('> ul.sub-menu', $item));
          } else {
            $navigation.css('min-height', '');
          }

        }

      });

    });

    // Back header returns to the top-level list -- same effect as clicking
    // the active TLML again, plus returning focus to it
    $back_trigger.on('click', function() {
      close_active_tlmi();
      if ($last_active_trigger) {
        $last_active_trigger.trigger('focus');
      }
    });

    // Mobile Menu Trigger opens/closes the whole panel
    $('#mm-trigger').on('click', function() {

      var $body = $('body');
      var was_open = $body.hasClass('mobile-menu-open');

      $body.toggleClass('mobile-menu-open', !was_open);

      // Always return to the top-level list, whether opening fresh or closing
      close_active_tlmi();

    });

    // Recompute the open Drop-Down's height/position on resize (e.g.
    // orientation change, or dragging the window narrower) rather than
    // leaving it sized/placed for the viewport it was opened at.
    $(window).on('resize', function() {

      var $active_item = $tlmis_with_sub_menus.filter('.active');

      if (!is_mobile_width()) {
        $navigation.css('min-height', '');
        if ($active_item.length) {
          position_drop_down($active_item, $('> ul.sub-menu', $active_item));
        }
        return;
      }

      // Defensive: catches a Drop-Down left open (not explicitly closed)
      // at desktop width before resizing narrow -- the close-time clear
      // above only runs on an actual close click, so this covers the gap.
      $tlmis_with_sub_menus.each(function() {
        $('> ul.sub-menu', $(this)).css({ left: '', width: '' });
      });

      var $active_sub_menu = $('> ul.menu > li.menu-item.active > ul.sub-menu', $navigation);
      if ($active_sub_menu.length) {
        apply_drilldown_height($active_sub_menu);
      }

    });

  });


  /* PRIMARY NAVIGATION -- RESIZE TRANSITION GUARD ------------------ */
  // A CSS transition fires on any computed-value change, not just a
  // deliberate class toggle -- including one caused by crossing the
  // 1200px media query breakpoint while resizing the window. Without
  // this, the nav's opacity/visibility transitions would visibly animate
  // for a moment every time the viewport crosses that boundary. Add
  // body.nav-no-transition (kills all transitions under #header, see
  // primary-navigation.scss) for the duration of the resize, then drop it
  // once things settle so deliberate open/close toggles still animate.
  var $body = $('body');
  var resize_timer;

  $(window).on('resize', function() {

    $body.addClass('nav-no-transition');
    clearTimeout(resize_timer);

    resize_timer = setTimeout(function() {
      $body.removeClass('nav-no-transition');
    }, 250);

  });

});
